import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    straightPayRate: Yup.number().required("Straight Pay Rate is required").nullable(),
    otPayRate: Yup.number().required("OT Pay Rate is required").nullable(),
});